module.exports = __webpack_public_path__ + "static/leftHome-af8f8c1864bee014342fc6038f7cb224.png";